(() => {
  const FLAG = '__tlFreeGiftAddingGiftSilently';
  let retryCount = 0;
  const MAX_RETRIES = 100;

  function installOverrides() {
    const offer = window.tlFreeGiftOffer;
    const CartDrawer = customElements.get('cart-drawer');
    
    let giftApplied = false;
    let drawerApplied = false;

    if (offer && !offer.__salepifyGiftFlagOverride) {
      offer.__salepifyGiftFlagOverride = true;
      const originalHandleAddGifts = offer.handleAddGifts;

      offer.handleAddGifts = async function(items = [], discountCodes = [], giftIdToShowNoti = []) {
        if (!Array.isArray(items) || items.length === 0) {
          return originalHandleAddGifts.call(this, items, discountCodes, giftIdToShowNoti);
        }

        window[FLAG] = true;
        try {
          return await originalHandleAddGifts.call(this, items, discountCodes, giftIdToShowNoti);
        } finally {
          setTimeout(() => { window[FLAG] = false; }, 1500);
        }
      };
      giftApplied = true;
    }

    if (CartDrawer && !CartDrawer.prototype.__salepifyNoOpenOverride) {
      CartDrawer.prototype.__salepifyNoOpenOverride = true;
      const originalOpen = CartDrawer.prototype.open;

      CartDrawer.prototype.open = function(triggeredBy) {
        if (window[FLAG]) return; 
        return originalOpen.call(this, triggeredBy);
      };
      drawerApplied = true;
    }

    return (offer && (CartDrawer || retryCount > 20));
  }

  const timer = setInterval(() => {
    retryCount++;
    if (installOverrides() || retryCount > MAX_RETRIES) {
      clearInterval(timer);
    }
  }, 50);
})();
